import type {LocalTrackerSession} from './local-session';

type PrivateFile={write:(content:string)=>void;share:()=>Promise<void>;remove:()=>void};
type Destination={download:(content:string)=>void}|{available:()=>Promise<boolean>;create:()=>PrivateFile};

// Keep the account boundary through OS share-sheet preparation, after the HTTP
// request has already finished. A logout cannot be undone by signing in again.
export async function exportAccountFile(session:Pick<LocalTrackerSession,'getSnapshot'|'subscribe'|'accountExport'>,mounted:()=>boolean,destination:Destination){
 const initial=session.getSnapshot();let active=initial.signedIn;
 const check=()=>{const current=session.getSnapshot();if(!mounted()||!current.signedIn||current.accountEmail!==initial.accountEmail||current.address!==initial.address||current.mode!==initial.mode)active=false;return active;};
 const unsubscribe=session.subscribe(check);
 const requireCurrent=()=>{if(!check())throw Error('account_export_cancelled');};
 try{
  requireCurrent();const data=await session.accountExport();requireCurrent();
  const content=JSON.stringify(data,null,2);
  if('download' in destination){requireCurrent();destination.download(content);}
  else{
   const available=await destination.available();requireCurrent();if(!available)throw Error('sharing_unavailable');
   const file=destination.create();
   try{requireCurrent();file.write(content);requireCurrent();await file.share();}finally{file.remove();}
  }
  requireCurrent();
 }finally{unsubscribe();}
}
